(function () {
    'use strict';

    angular.module('formonlineApp')
        .config(translateConfig);

    translateConfig.$inject = ['$translateProvider'];

    function translateConfig($translateProvider) {
        $translateProvider.useUrlLoader('api/messageSource');
        $translateProvider.preferredLanguage('fr');
        $translateProvider.fallbackLanguage('fr');
        $translateProvider.useCookieStorage();
        $translateProvider.useSanitizeValueStrategy('escaped');
    }
})();
